// Package imports:
import React from 'react';

const Censored: React.FC = () => {
    return (
        <div className='KCL_censored'></div>
    );
}

export default Censored;